var paragraph_default = {
  "fontElementMap": "oCtM9",
  "elementSpacing": "JJG54",
  "text": "cNrMm JJG54",
  "child": "umEtl"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
